import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=516adf7c&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"
import style0 from "./Pos.vue?vue&type=style&index=0&id=516adf7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516adf7c",
  null
  
)

export default component.exports